"use client";
import type { JSX } from "react";
import React from "react";
import { logError } from "@jetblue/dotcom-fe-logger";
import ASAPP from ".";

type AsappProperties = {
  asappAppId: string;
  asappHostname: string;
  sherpaAppId: string;
  affiliateId: string;
  // autoOpenUrls: string[];
  // canBeginChatUrls: string[];
};

export function AsappClient({
  asappAppId,
  asappHostname,
  sherpaAppId,
  affiliateId,
  //   autoOpenUrls,
  //   canBeginChatUrls,
}: AsappProperties): JSX.Element | null {
  React.useEffect(() => {
    // ASAPP Chat SDK
    const bootstrap = document.createElement("script");
    bootstrap.type = "text/javascript";
    bootstrap.text = `(function (w, d, h, n, s) {
      s = d.createElement('script');
      (w[n] =
        w[n] ||
        function () {
          (w[n]._ = w[n]._ || []).push(arguments);
        }),
        (w[n].Host = h),
        (s.async = 1),
        (s.src = h + '/chat-sdk.js'),
        (s.type = 'text/javascript'),
        d.body.appendChild(s);
    })(window, document, 'https://sdk.asapp.com', 'ASAPP')`;
    const onAsappLoad = () => {
      ASAPP.asappLoad(asappAppId, asappHostname);
    };
    const onError = (error: ErrorEvent) => {
      void logError({
        error,
        message: "Failed to load Asapp or Sherpa script",
      });
    };
    bootstrap.addEventListener("load", onAsappLoad);
    bootstrap.addEventListener("error", onError);
    document.head.append(bootstrap);

    // SHERPA Script
    if (!sherpaAppId || !affiliateId) {
      return;
    }
    const sherpa = document.createElement("script");
    sherpa.src = `https://sdk.joinsherpa.io/widget.js?appId=${sherpaAppId}&affiliateId=${affiliateId}`;

    document.head.append(sherpa);

    return () => {
      bootstrap.removeEventListener("load", onAsappLoad);
      bootstrap.removeEventListener("error", onError);
      sherpa.remove();
      bootstrap.remove();
    };
  }, [sherpaAppId, affiliateId]);

  return null;
}
